import { defineStore } from 'pinia';
import store from '@/stores';
import { createLocalStorage } from '@/utils/cache';
const ls = createLocalStorage();
const lsLocaleSetting = ls.get('defaultServer') || {};

export interface userState {
    vehicleInfo: Record<string, string>;
    vehicleList: any[];
    serverList: any[];
    defaultServer: {
        id?: number;
        name?: string;
    };
}

export const useVehicleStore = defineStore({
    id: 'app-vehicle',
    state: (): userState => {
        return {
            vehicleInfo: {},
            vehicleList: [],
            serverList: [],
            defaultServer: typeof lsLocaleSetting === 'string' ? JSON.parse(lsLocaleSetting) : lsLocaleSetting
        };
    },
    getters: {},
    actions: {
        updateState<K extends keyof userState>(key: K, value: userState[K]) {
            // @ts-ignore
            this[key] = value;
            ls.set('defaultServer', JSON.stringify(this.defaultServer));
        }
    }
});

export function useVehicleStoreWithOut() {
    return useVehicleStore(store);
}
